import { Dialog } from '@ordr-as/umami-react'
import { FavritApp, PaymentMethodCountryConnectionDto } from '../../generated-api'
import { useCreatePaymentMethodCountryConnection } from 'hooks/usePaymentMethodApi'
import { mapFavritAppToName } from 'utils/favritAppUtils'
import { mapCountryCodeToCountryName } from 'utils/countryUtils'

type RemoveAppFromCountryDialogProps = {
    countryConnection: PaymentMethodCountryConnectionDto
    favritApp: FavritApp
    dialogIsOpen: boolean
    onClose: () => void
}

const RemoveAppFromCountryDialog = (props: RemoveAppFromCountryDialogProps) => {
    const { countryConnection, favritApp, dialogIsOpen, onClose } = props

    const { mutate: runCreateCountryConnection, isLoading: isCreatingCountryConnection } =
        useCreatePaymentMethodCountryConnection(
            countryConnection.paymentProvider,
            countryConnection.paymentMethod,
            countryConnection.countryCode
        )

    const handleRemoveApp = () => {
        const updatedApps = new Set(countryConnection.defaultEnabledInApps)
        updatedApps.delete(favritApp)

        runCreateCountryConnection(
            {
                paymentsEnabled: countryConnection.paymentsEnabled,
                defaultEnabledInApps: updatedApps,
            },
            {
                onSuccess: () => {
                    onClose()
                },
            }
        )
    }

    return (
        <div className="inline-block group relative flex-none">
            {dialogIsOpen && (
                <Dialog
                    title="Remove app"
                    onClose={() => onClose()}
                    actionLabel={isCreatingCountryConnection ? 'Removing...' : 'Remove app'}
                    onAction={handleRemoveApp}
                    secondaryActionLabel={'Cancel'}
                    onSecondaryAction={() => {
                        onClose()
                    }}
                    isDisabledAction={isCreatingCountryConnection}
                    isDisabledSecondaryAction={isCreatingCountryConnection}
                >
                    This will remove the {countryConnection.paymentProvider} - {countryConnection.paymentMethod} payment
                    method from the <span className="text-bold">{mapFavritAppToName(favritApp)}</span> for all customers
                    in {mapCountryCodeToCountryName(countryConnection.countryCode)}.
                    <br />
                    <br />
                    Note that any locations that specify the app in their location-specific configuration will still
                    show the payment method in the app.
                </Dialog>
            )}
        </div>
    )
}

export default RemoveAppFromCountryDialog
